/* Built In Imports */
import { useSearchParams } from 'next/navigation';
import axios from 'axios';
import { Field, Form, Formik } from 'formik';
import parser from 'html-react-parser';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { createRef, useEffect, useState } from 'react';
import * as Yup from 'yup';
const ReCAPTCHA = dynamic(() => import('react-google-recaptcha'));

/* External Imports */
import { Box, Button, Flex, FormControl, FormErrorMessage, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay } from "@chakra-ui/react";
import config from '@config';

/* Internal Imports */
import InputUI from '@landing_pages/lb/components/Footer/InputUI';

const PartnerWithusForm = ({ isOpen, onClose, formElement }) => {
    const searchParams = useSearchParams();
    const router = useRouter();
    const [isLoading, setLoading] = useState(false);
    const [err, setErr] = useState('');
    const [successMsg, setsuccessMsg] = useState('');
    const recaptchaRef = createRef(null);

    const [initialValues, setInitialValues] = useState({
        name: '',
        company_name: '',
        email: '',
        phone_number: '',
        interested: ''
    });

    useEffect(() => {
        if (recaptchaRef && recaptchaRef?.current) {
            recaptchaRef?.current?.retry();
        }
    }, []);

    const CSRSchema = Yup.object().shape({
        name: Yup.string()
            .min(2, 'Full Name is invalid')
            .matches(/^([a-zA-Z ])+$/u, {
                message: 'Full Name is invalid',
            })
            .max(100, 'Full Name is invalid')
            .required('Full Name is required'),
        company_name: Yup.string()
            .matches(/^([a-zA-Z ])+$/u, {
                message: 'Company Name is invalid',
            })
            .max(100, 'Company Name Invalid')
            .required('Company Name is required'),
        email: Yup.string()
            .matches(/^[a-zA-Z]+[a-zA-Z0-9._]+@[a-zA-Z]+\.[a-zA-Z.]{2,15}$/, {
                message: 'Email is invalid',
            })
            .required('Email is required'),
        phone_number: Yup.string()
            .matches(/^[0-9]+$/, "Phone must be a number")
            .min(10, 'Must be exactly 10 digits')
            .max(10, 'Must be exactly 10 digits')
    });

    const onSubmit = async (values) => {
        setLoading(true);
        const enquiryData = {
        message: {
            systemId: '110',
            programType: 'CSR Leads',
            name: `${values.name}`,
            companyName: values.company_name,
            email: values.email || '',
            phone: `${values.phone_number}`,
            country: 'IN',
            utmCampaign: searchParams.get('utmCampaign'),
            utmMedium: searchParams.get('utmMedium'),
            utmSource: searchParams.get('utmSource'),
            utmTerm: searchParams.get('utmTerm'),
            utmReferer: searchParams.get('utmReferer'),
            programYear: '2025',
            user_responses: [{
                'prompt': 'Projects Interested in',
                'selectionValues': `${values.interested}`,
            }]
        },
        };
        const finalObj = {
            enquiryData,
            source: `${config.BASE_PATH}${router.asPath}`
        };
        console.log('source',`${config.BASE_PATH}${router.asPath}`);
        axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            url: `${config.CSR_PARTNERWITHUS_FORM}`,
            data: enquiryData,
        })
            .then(response => {
                console.log('response',{ response });
                if (response && response?.status) {
                    const resp = response?.status;
                    const status1 = resp;
                    //   console.log('status', status1 );
                    if (response.status === 200) {
                        setsuccessMsg(response?.statusText || '<p>Thank you for your interest in partnering with us.<br/><br/>Our team will get in touch with you shortly.</p>');
                        setLoading(false);
                        return;
                    } else if (status1 === 'Failure') {
                        // setErr(resp?.error || 'Cannot register for the program');
                        setsuccessMsg(response?.error || 'Cannot register for the program');
                        setLoading(false);
                        return;
                    } else {
                        setErr('Something went wrong');
                        setLoading(false);
                        return;
                    }
                } else {
                    setErr('Response by server is not handled');
                    setLoading(false);
                    return;
                }
            })
            .catch(err => {
                console.log('err:', { err });
                setLoading(false);
                setErr(err?.response?.status || 'Unknown error');
            });
    };
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            {/* maxW={{ base: '90%', md: '547px' }} */}
            <ModalOverlay />
            <ModalContent maxW={{base:'90%', md:'547px'}} m="auto">
                <ModalCloseButton color={'#BB3E03'} display={!successMsg ? 'block' : 'none' } />
            <ModalBody padding="0px">
          {/* width={{ base: "85%", md: "547px" }}  */}
                        <Flex
                            flexDirection={"column"}
                            mx={{ base: 'auto' }}
                            alignItems="center"
                            justifyContent="center"
                            backgroundImage={formElement?.bgImage?.desktop}
                            backgroundSize={'cover'}
                            backgroundRepeat={'no-repeat'}
                            padding={{ base: "20px 23px", md: "40px 49px 10px 49px" }}
                            m="0"
                        >
                            {successMsg ? (
                                <Box
                                    id="successMessage"
                                    color="#000"
                                    width={{ base: '248px', md: '504px' }}
                                    height={{ base: '248px', md: '504px' }}
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    textAlign="center"
                                    fontSize={{ base: '22px', md: '24px' }}
                                    mt={{ base: '-10', md: '-36' }}
                                >
                                    {parser(successMsg || '')}
                                </Box>
                            ) : (
                                <>
                                    <Box>
                                        <Box mb="10px" textAlign={'center'} fontFamily="FedraSerifAStdBook" fontWeight={'bold'} fontSize={{ base: '22px', md: '28px' }}>{formElement.title}</Box>
                                        <Formik
                                            initialValues={initialValues}
                                            validationSchema={CSRSchema}
                                            onSubmit={onSubmit}
                                            enableReinitialize
                                        >
                                            {props => (
                                                <Form onSubmit={props.handleSubmit}>
                                                    <Field name="name">
                                                        {({ field, form }) => (
                                                            <FormControl
                                                                isInvalid={form?.errors?.name && form?.touched?.name}
                                                                isRequired
                                                                width={{ base: '100%' }}
                                                            >
                                                                <InputUI
                                                                    field={field}
                                                                    bg='white'
                                                                    id="name"
                                                                    variant="outline"
                                                                    onChange={props.handleChange}
                                                                    isRequired={true}
                                                                    placeholder={formElement.namePlaceholder}
                                                                    fontSize={{ base: '16px', md: '18px' }}
                                                                    color="#6A6565"
                                                                    width={{ base: '100%', md: '449px' }}
                                                                    p={2}
                                                                    className="bottom-border-fields" />
                                                                <FormErrorMessage
                                                                    justifyContent="left"
                                                                    color="#E73E3E"
                                                                    fontSize="16px"
                                                                    fontFamily="'FedraSansStd-book', sans-serif"
                                                                    marginLeft={'16px'}
                                                                    marginTop={'0px'}
                                                                >
                                                                    {form?.errors?.name}
                                                                </FormErrorMessage>
                                                            </FormControl>
                                                        )}
                                                    </Field>
                                                    <Field name="company_name">
                                                        {({ field, form }) => (
                                                            <FormControl
                                                                isInvalid={form?.errors?.company_name && form?.touched?.company_name}
                                                                isRequired
                                                                width={{ base: '100%' }}
                                                            >
                                                                <InputUI
                                                                    field={field}
                                                                    bg='white'
                                                                    id="company_name"
                                                                    variant="outline"
                                                                    onChange={props.handleChange}
                                                                    isRequired={true}
                                                                    placeholder={formElement.companyPlaceholder}
                                                                    fontSize={{ base: '16px', md: '18px' }}
                                                                    color="#6A6565"
                                                                    width={{ base: '100%', md: '449px' }}
                                                                    p={2}
                                                                    className="bottom-border-fields" />
                                                                <FormErrorMessage
                                                                    justifyContent="left"
                                                                    color="#E73E3E"
                                                                    fontSize="16px"
                                                                    fontFamily="'FedraSansStd-book', sans-serif"
                                                                    marginLeft={'16px'}
                                                                    marginTop={'0px'}
                                                                >
                                                                    {form?.errors?.company_name}
                                                                </FormErrorMessage>
                                                            </FormControl>
                                                        )}
                                                    </Field>
                                                    <Field name="email">
                                                        {({ field, form }) => (
                                                            <FormControl
                                                                isInvalid={form?.errors?.email && form?.touched?.email}
                                                                isRequired
                                                                width={{ base: '100%' }}
                                                            >
                                                                <InputUI
                                                                    field={field}
                                                                    bg='white'
                                                                    id="email"
                                                                    variant="outline"
                                                                    onChange={props.handleChange}
                                                                    isRequired={true}
                                                                    placeholder={formElement.emailPlaceholder}
                                                                    fontSize={{ base: '16px', md: '18px' }}
                                                                    color="#6A6565"
                                                                    width={{ base: '100%', md: '449px' }}
                                                                    p={2}
                                                                    className="bottom-border-fields" />
                                                                <FormErrorMessage
                                                                    justifyContent="left"
                                                                    color="#E73E3E"
                                                                    fontSize="16px"
                                                                    fontFamily="'FedraSansStd-book', sans-serif"
                                                                    marginLeft={'16px'}
                                                                    marginTop={'0px'}
                                                                >
                                                                    {form?.errors?.email}
                                                                </FormErrorMessage>
                                                            </FormControl>
                                                        )}
                                                    </Field>
                                                    <Field name="phone_number">
                                                        {({ field, form }) => (
                                                            <FormControl
                                                                isInvalid={form?.errors?.phone_number && form?.touched?.phone_number}
                                                                width={{ base: '100%' }}
                                                            >
                                                                <InputUI
                                                                    field={field}
                                                                    bg='white'
                                                                    id="phone_number"
                                                                    variant="outline"
                                                                    onChange={props.handleChange}
                                                                    placeholder={formElement.phonePlaceholder}
                                                                    fontSize={{ base: '16px', md: '18px' }}
                                                                    color="#6A6565"
                                                                    width={{ base: '100%', md: '449px' }}
                                                                    p={2}
                                                                    className="bottom-border-fields" />
                                                                <FormErrorMessage
                                                                    justifyContent="left"
                                                                    color="#E73E3E"
                                                                    fontSize="16px"
                                                                    fontFamily="'FedraSansStd-book', sans-serif"
                                                                    marginLeft={'16px'}
                                                                    marginTop={'0px'}
                                                                >
                                                                    {form?.errors?.phone_number}
                                                                </FormErrorMessage>
                                                            </FormControl>
                                                        )}
                                                    </Field>
                                                    <Field name="interested">
                                                        {({ field, form }) => (
                                                            <FormControl
                                                                isInvalid={form?.errors?.interested && form?.touched?.interested}
                                                                width={{ base: '100%' }}
                                                            >
                                                                <InputUI
                                                                    field={field}
                                                                    bg='white'
                                                                    id="projects"
                                                                    variant="outline"
                                                                    onChange={props.handleChange}
                                                                    placeholder={formElement.projectPlaceholder}
                                                                    fontSize={{ base: '16px', md: '18px' }}
                                                                    color="#6A6565"
                                                                    width={{ base: '100%', md: '449px' }}
                                                                    p={2}
                                                                    className="bottom-border-fields" />
                                                            </FormControl>
                                                        )}
                                                    </Field>
                                                    <Flex
                                                        flexDirection={{ base: 'column', md: 'row' }}
                                                        maxW={{ base: 'auto', xl: '386px' }}
                                                        mx={{ md: '0', xl: 'auto' }}
                                                        placeItems="center"
                                                        mt={{ base: '10px', sm: '0px' }}
                                                        gridAutoFlow={{ base: 'row', md: 'column' }}
                                                        alignContent="center"
                                                        justifyContent={{ md: 'flex-start', xl: 'left' }}
                                                        marginLeft={'0px !important'}
                                                    >
                                                        <Field name="recaptcha">
                                                            {({ field, form }) => (
                                                                <FormControl
                                                                    isInvalid={
                                                                        form?.errors?.recaptcha && form?.touched?.recaptcha
                                                                    }
                                                                    m={{ base: '0', md: '0 0px' }}
                                                                    textAlign="center"
                                                                    overflow={{ base: 'hidden', lg: 'visible' }}
                                                                    maxW={{ base: '270px', lg: '290px' }}
                                                                    w="100%"
                                                                    maxH={20}
                                                                >
                                                                    <Box
                                                                        mx={{ base: 'auto', md: '0' }}
                                                                        mt={{ base: '0', md: '0', lg: '4px' }}
                                                                        style={{
                                                                            transform: 'scale(0.8)',
                                                                            transformOrigin: '15px 20px',
                                                                        }}
                                                                    >
                                                                        {config?.RECAPTCHA_KEY && (
                                                                            <ReCAPTCHA
                                                                                ref={recaptchaRef}
                                                                                sitekey={config?.RECAPTCHA_KEY}
                                                                                onChange={success => {
                                                                                    success === null
                                                                                        ? recaptchaRef?.current?.reset()
                                                                                        : props.setFieldValue('recaptcha', success);
                                                                                }}
                                                                                onErrored={error => {
                                                                                    props.setFieldValue('recaptcha', '');
                                                                                    recaptchaRef?.current?.reset();
                                                                                }}
                                                                                size="normal"
                                                                            />
                                                                        )}
                                                                    </Box>
                                                                    <FormErrorMessage justifyContent="left">
                                                                        {form?.errors?.recaptcha}
                                                                    </FormErrorMessage>
                                                                </FormControl>
                                                            )}
                                                        </Field>
                                                    </Flex>
                                                    <Box marginTop="10px" width={{ base: '100%' }}>
                                                        <Box as="div" marginTop="30px" textAlign="center">
                                                            <Button
                                                                type="submit"
                                                                isLoading={isLoading}
                                                                display="inline-block"
                                                                mb="20px"
                                                                fontFamily="FedraSansStd-medium"
                                                                borderRadius="8px"
                                                                bgColor="#cf4520"
                                                                color="rgb(250 247 240)"
                                                                fontSize="16px"
                                                                padding="10px 35px"
                                                                _hover={{
                                                                    textDecoration: 'none',
                                                                }}
                                                                minW={'180px'}
                                                                height={'60px'}
                                                            // disabled={!props.isValid ? (loading ? true : false) : true}
                                                            >
                                                                {formElement.submitButton}
                                                            </Button>
                                                        </Box>
                                                    </Box>
                                                </Form>
                                            )}
                                        </Formik>
                                    </Box>
                                </>
                            )}
                        </Flex>
                        <style jsx global>
                            {`
                    .bottom-border-fields {
                        border-radius: 5px;
                        padding-left: 30px !important;
                        font-family: "FedraSansStd-book";
                        height: 68px !important;
                        margin-top: 10px;
                        color: #6A6565;
                    }
                    #successMessage .csr-popup-btn a {
                        padding: 16px 36px;
                        font-size: 18px;
                        font-family: 'FedraSansStd-medium', sans-serif;
                        line-height: 1.3333333;
                        font-weight: normal;
                        border: 1px solid #ccc;
                        cursor: pointer;
                        width: 160px;
                        height: 60px;
                        display: inline-block;
                        border-radius: 4px;
                        margin-top: 40px;
                    }
                    #successMessage .csr-popup-btn a,
                    #successMessage .csr-popup-btn a.active,
                    #successMessage .csr-popup-btn a:active {
                        color: #fff;
                        background-color: #cf4520;
                        border-radius: 3px;
                    }
                    #successMessage .csr-popup {
                        margin-top: 110px;
                    }
                    #successMessage .csr-popup-btn a:hover {
                        color: #fff !important;
                        background-color: #892a16;
                        border-color: #cd6727;
                    }
                    #successMessage .csr-popup-btn a:active:hover {
                        border-color: #8c8c8c;
                    }
                    #successMessage .csr-popup-btn a:active:focus {
                        outline: 5px auto -webkit-focus-ring-color;
                        outline-offset: -2px;
                    }
                    #successMessage .csr-popup-btn a:focus {
                        color: #cf4520 !important;
                    }
                    #successMessage .csr-popup, #successMessage .csr-popup p {
                        font-family="FedraSansStd-book"
                        font-size: 20px;
                        padding: 16px 0;
                    }
                    #successMessage {
                        height: 532px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                    @media (max-width: 767px) {
                        .bottom-border-fields {
                            border-radius: 5px;
                            padding-left: 30px !important;
                            font-family: "FedraSansStd-book";
                            height: 54px !important;
                        }
                    } 
                    `}
                        </style>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default PartnerWithusForm